export const CREATE_DASHBOARD_CSV_EXPORT_LOG = {
  from: 'src/modules/dashboard/export-csv-button',
  name: 'Creates a CSV export',
  message: 'Sends a request to generate an email with a CSV listing the folder entities',
}
